export default __webpack_public_path__ + "static/media/rafael_pedicini-560.8d09b025.jpg";